export const PARTICIPANT_LAYOUT_ROOT_SELECTOR = "[data-participant-layout-root]";

export function isParticipantLayout2DViewActive(doc = typeof document !== "undefined" ? document : null) {
  return Boolean(doc?.querySelector?.(PARTICIPANT_LAYOUT_ROOT_SELECTOR));
}
